import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route } from '@angular/router';
import { PermissionService } from './permission-service';
import { ToasterService } from 'app/services/toaster.service';

@Injectable()
export class AuthGuard  {
    constructor(private permissionService: PermissionService, private router: Router,
        private toastr: ToasterService) { }

    canLoad(route: Route): boolean {
        return this.permissionService.hasToken();
    }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const isSetUp = this.permissionService.hasSetUp();
        if (isSetUp) {
            this.router.navigate(['/register']);
            return false;
        }
        const isToken = this.permissionService.hasToken();
        if (!isToken) {
            // this.toastr.warning('You need To Login', 'Sorry!!');
            this.router.navigate(['/login-stoda']);
        }
        return isToken;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }
}
